/**
 * Membership types used throughout the application for signup flows and user classification.
 * These constants define the different membership levels and promotional programs available.
 *
 * @constant {Object} SignupMemberships
 */
export const SignupMemberships = {
  /**
   * Guest membership - for non-registered users browsing the site.
   * Used to identify users who haven't created an account yet.
   */
  GUEST: 'Guest',

  /**
   * VIP membership - premium membership tier with exclusive benefits.
   * VIP members get special pricing, early access to products, and other perks.
   */
  VIP: 'Vip',

  /**
   * GSHOP membership - promotional membership program offering special pricing.
   * Used for customers who qualify for guest shopping benefits without VIP membership.
   * Activated via promo codes or specific marketing campaigns.
   */
  GSHOP: 'GSHOP',

  /**
   * GSHOP MSRP membership - GSHOP variant that uses manufacturer's suggested retail price.
   * Similar to GSHOP but with different pricing structure based on MSRP instead of regular pricing.
   * Used for specific promotional campaigns that require MSRP-based pricing.
   */
  GSHOP_MSRP: 'GSHOP_MSRP',

  /**
   * GSHOP MSRP membership - GSHOP variant that uses a discount off the manufacturer's suggested retail price.
   */
  GSHOP_MSRP_DISCOUNT: 'GSHOP_MSRP_DISCOUNT',
};
